import request from '@/axios/index.js'
const uri = '/user/rcvbBuy/';
export function selectSellerCst(data) {
    return request.axios({
        url: uri+'selectSellerCst',
        data: data
    })
}
export function findRcvbBuyInptList(data) {
    return request.axios({
        url: uri+'findRcvbBuyInptList',
        data: data
    })
}
export function cancelRcvb(data) {
    return request.axios({
        url: uri+'cancelRcvb',
        data: data,
        loading:true
    })
}





// WEBPACK FOOTER //
// ./src/api/rcvbBuy.js